import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // Import the detector
import en from './en/translations.json';
import de from './de/translations.json';

i18n
  .use(LanguageDetector) // Use the language detection plugin
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    lng: 'en', // This can be removed, as the detector will set the language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator'], // Prioritize cookie detection
      caches: ['cookie'], // Store the language in a cookie
      lookupCookie: 'i18next_lang', // Optional: customize the cookie name
      cookieOptions: {
        path: '/',
        sameSite: 'strict',
        maxAge: 365 * 24 * 60 * 60, // 1 year in seconds
      },
    },
  });

export default i18n;